/** @jsxImportSource @emotion/react */
import { Button, Typography } from '@quickbit/qb-design-system';
import { useState } from 'react';
import { useAsyncFn, useMount } from 'react-use';
import { Loading, Header, EmptyContent } from '../../components';
import { Role } from '../../types';
import { fetchGroups, fetchPermissions } from './api';
import { RoleDetails } from './components/details';
import { RoleSearch } from './components/search';

export const UserRoles = () => {
  const [{ value, loading, error }, fetchAll] = useAsyncFn(() =>
    Promise.all([fetchGroups(), fetchPermissions()])
  );

  useMount(() => fetchAll());

  const [selectedRole, setSelectedRole] = useState<Role | 'new'>();

  if (loading) return <Loading loading={loading} />;

  return (
    <div>
      {error && (
        <>
          <Header>
            <Typography variant="subtitle">User Roles</Typography>
          </Header>
          <EmptyContent
            heading="Oops! It's empty."
            body="Something went wrong"
            action={
              <Button
                text="Try again"
                variant="primary"
                onClick={() => fetchAll()}
              />
            }
          />
        </>
      )}
      {value && (
        <>
          {!selectedRole && (
            <RoleSearch roles={value[0]} setSelectedRole={setSelectedRole} />
          )}
          {selectedRole && (
            <RoleDetails
              role={selectedRole}
              permissions={value[1]}
              cancel={() => {
                setSelectedRole(undefined);
                void fetchAll();
              }}
            />
          )}
        </>
      )}
    </div>
  );
};
